import { getHasuraRoleFromToken } from "common";
import useUserAuth from "../useUserAuth";
export default function useHasuraRole() {
    const { userToken, loading, error } = useUserAuth();
    return {
        loading,
        data: userToken ? getHasuraRoleFromToken(userToken) : null,
        error,
    };
}
//# sourceMappingURL=index.js.map